import React from "react"
type Props = {
  desc?: any
  pageTitle: string
  bg: string
  white?: boolean
}

const HireProcessQa: React.FC<Props> = ({ pageTitle, desc, bg, white }) => {
  return (
    <section className={`section-py ${bg} process-section`}>
      <div
        className={
          white
            ? "text-white container lg:container mx-auto"
            : "container lg:container mx-auto"
        }
      >
       <div className="row grid md:grid-cols-12 !gap-y-0">
          <div className="md:col-span-8 md:col-start-3 mb-5 md:mb-[70px] lg:mb-0">
            <div className="flex flex-col gap-2.5 text-center">
              <h2 className="mb-0">{pageTitle}</h2>
              <p className={white ? "text-white mb-0 fw-600" : "mb-0 fw-600"}>
                {desc}
              </p>
            </div>
          </div>
          <div className="md:col-span-12 xl:col-span-12 xxl:col-span10 text-center about-us-animation">
            <div className="process-list process-list-about">
              <div
                className={
                  white
                    ? "process-item process-item-white text-center"
                    : "process-item text-center"
                }
              >
                <div
                  className={
                    white
                      ? "process-icon process-icon-white mx-auto mb-4 grid rounded-full"
                      : "process-icon mx-auto mb-4 grid rounded-full"
                  }
                >
                  <svg>
                    <use xlinkHref="#ic-requirement" />
                  </svg>
                </div>
                <p
                  className={
                    white
                      ? "text-white fw-500 px-2.5 mb-[15px] custom-min-height"
                      : "text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height"
                  }
                >
                  Requirement Gathering
                </p>
                <p className={
                  white 
                  ? "text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                  : "text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                }>
                  We start by gathering and comprehensively understanding your project&apos;s requirements.
                </p>
              </div>
              <div
                className={
                  white
                    ? "circle circle-white circle-reverse"
                    : "circle circle-reverse"
                }
              />
              <div
                className={
                  white
                    ? "process-item  process-item-white process-item-reverse text-center"
                    : "process-item process-item-reverse text-center"
                }
              >
                <div
                  className={
                    white
                      ? "process-icon process-icon-white process-icon-reverse mx-auto mb-4 grid rounded-full"
                      : "process-icon process-icon-reverse mx-auto mb-4 grid rounded-full"
                  }
                >
                  <svg>
                    <use xlinkHref="#ic-analysis" />
                  </svg>
                </div>
                <p
                  className={
                    white
                      ? "text-white fw-500 px-2.5 mb-[15px] custom-min-height"
                      : "text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height"
                  }
                >
                  Impact Analysis
                </p>
                <p className={
                  white 
                  ? "text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                  : "text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                }>
                  We assess how changes and improvements will impact your project.
                </p>
              </div>
              <div
                className={
                  white ? "circle circle-white circle-2" : "circle circle-2"
                }
              />
              <div
                className={
                  white
                    ? "process-item process-item-white text-center"
                    : "process-item text-center"
                }
              >
                <div
                  className={
                    white
                      ? "process-icon process-icon-white mx-auto mb-4 grid rounded-full"
                      : "process-icon mx-auto mb-4 grid rounded-full"
                  }
                >
                  <svg className="color-transparent">
                    <use xlinkHref="#ic-planning-test" />
                  </svg>
                </div>
                <p
                  className={
                    white
                      ? "text-white fw-500 px-2.5 mb-[15px] custom-min-height"
                      : "text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height"
                  }
                >
                  Planning Test Procedure
                </p>
                <p className={
                  white 
                  ? "text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                  : "text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                }>
                  We create a precise plan for testing procedures tailored to your project&apos;s needs.
                </p>
              </div>
              <div
                className={
                  white
                    ? "circle circle-white circle-reverse circle-3"
                    : "circle circle-reverse circle-3"
                }
              />
              <div
                className={
                  white
                    ? "process-item process-item-white process-item-reverse text-center"
                    : "process-item process-item-reverse text-center"
                }
              >
                <div
                  className={
                    white
                      ? "process-icon process-icon-white mx-auto mb-4 grid rounded-full"
                      : "process-icon mx-auto mb-4 grid rounded-full"
                  }
                >
                  <svg className="color-transparent">
                    <use xlinkHref="#ic-regression-testing" />
                  </svg>
                </div>
                <p
                  className={
                    white
                      ? "text-white fw-500 px-2.5 mb-[15px] custom-min-height"
                      : "text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height"
                  }
                >
                  Continuous Testing & Improvement (Regression Testing)
                </p>
                <p className={
                  white 
                  ? "text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                  : "text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                }>
                  We continually test and improve, ensuring that every aspect of your project remains robust and error-free.
                </p>
              </div>
              <div
                className={
                  white ? "circle circle-white circle-4" : "circle circle-4"
                }
              />
              <div
                className={
                  white
                    ? "process-item process-item-white text-center"
                    : "process-item text-center"
                }
              >
                <div
                  className={
                    white
                      ? "process-icon process-icon-white mx-auto mb-4 grid rounded-full"
                      : "process-icon mx-auto mb-4 grid rounded-full"
                  }
                >
                  <svg>
                    <use xlinkHref="#ic-generate-report" />
                  </svg>
                </div>
                <p
                  className={
                    white
                      ? "text-white fw-500 px-2.5 mb-[15px] custom-min-height"
                      : "text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height"
                  }
                >
                  Report Generation
                </p>
                <p className={
                  white 
                  ? "text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                  : "text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                }>
                  We provide you with detailed reports, keeping you informed about the progress and results of our testing.
                </p>
              </div>
              <div
                className={
                  white
                    ? "circle circle-white circle-reverse circle-5"
                    : "circle circle-reverse circle-5"
                }
              />
                <div
                className={
                  white
                    ? "process-item process-item-white process-item-reverse text-center"
                    : "process-item process-item-reverse text-center"
                }
              >
                <div
                  className={
                    white
                      ? "process-icon process-icon-white mx-auto mb-4 grid rounded-full"
                      : "process-icon mx-auto mb-4 grid rounded-full"
                  }
                >
                  <svg>
                    <use xlinkHref="#ic-monitoring" />
                  </svg>
                </div>
                <p
                  className={
                    white
                      ? "text-white fw-500 px-2.5 mb-[15px] custom-min-height"
                      : "text-textcolor fw-500 px-2.5 mb-[15px] custom-min-height"
                  }
                >
                  Monitoring
                </p>
                <p className={
                  white 
                  ? "text-white fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                  : "text-textcolor fs-md fw-400 mb-0 px-3 minheight-cardinner-pag"
                }>
                We monitor the quality of your project throughout its lifecycle, guaranteeing a consistently high standard.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HireProcessQa
